// angular
import { ChangeDetectionStrategy, Component } from '@angular/core';
// libs
import { DynamicFormBaseComponent } from '@luggagehero/features/ui';

@Component({
  exportAs: 'lhDynamicForm',
  selector: 'lh-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DynamicFormComponent extends DynamicFormBaseComponent {}
